// Layout
const dashboardLayout = () => import('@/layouts/DriverLayout/DashboardLayout/dashboardLayout.vue')

const setting = () => import('./views/index')

// start Routes
export default [
  {
    path: '/driver/settings',
    component: dashboardLayout,
    children: [{
      path: '',
      name: 'driverSettings',
      meta: {
        name: 'driverSettings',
        parentName: 'marketplace',
        userType: '',
        permission: '',
        role: 'transportation.driver'
      },
      component: setting
    }
    ]
  }
]
